var variantImageAutomator = function () {
    function create_element_append_to_body(el, elId, display) {
      display || (display = "none");
      var g = document.createElement(el);
      (g.id = elId),
        (g.style = "display:" + display),
        document.body.appendChild(g);
    }
    function find_current_variant(section) {
      var variant_id,
        element = section || document;
      default_variant =
        0 == default_variant ? Object.keys(product_variants)[0] : default_variant;
      var queries = {};
      if (
        (document.location.search
          .substr(1)
          .split("&")
          .forEach(function (q) {
            var i = q.split("=");
            try {
              queries[i[0].toString()] = i[1].toString();
            } catch (err) {}
          }),
        isNaN(queries.variant))
      ) {
        let selector =
          element.querySelector('form[action="/cart/add"] [name="id"]:checked') ||
          element.querySelector('form[action="/cart/add"] [name="id"]') ||
          element.querySelector('select[name="id"]') ||
          element.querySelector('[name="id"]');
        variant_id = selector ? selector.value : default_variant;
      } else
        variant_id = queries.variant
          ? queries.variant
          : element.querySelector(
              "select option[value='" + default_variant + "']"
            ).parentNode.value;
      return variant_id || default_variant;
    }
    function is_variant_in_url() {
      return document.location.search.indexOf("variant=") >= 0;
    }
    function find_current_variant_from_url() {
      var variant_id,
        queries = {};
      return (
        document.location.search
          .substr(1)
          .split("&")
          .forEach(function (q) {
            var i = q.split("=");
            try {
              queries[i[0].toString()] = i[1].toString();
            } catch (err) {}
          }),
        isNaN(queries.variant)
          ? (variant_id = null)
          : queries.variant && (variant_id = queries.variant),
        variant_id
      );
    }
    function is_array_equal(a1, a2) {
      return JSON.stringify(a1) === JSON.stringify(a2);
    }
    function find_variant_media(variant_id) {
      var variant_media;
      if (
        (variant_id || (variant_id = find_current_variant()),
        variants_media.hasOwnProperty(variant_id)
          ? (variant_media = variants_media[variant_id])
          : ((variant_id = find_current_variant_from_url()),
            (variant_media = variants_media.hasOwnProperty(variant_id)
              ? variants_media[variant_id]
              : variants_media[default_variant])),
        (!variant_media || 0 == variant_media.length) &&
          skip_showcase_image >= product_media.length)
      )
        return product_media;
      if (
        !is_home &&
        "no_action" != only_run_if_variant_in_url &&
        !is_variant_in_url()
      ) {
        function showcase_images() {
          return variants_media.g.length
            ? variants_media.g
            : variant_assigned_media;
        }
        function skipped_and_showcase_images() {
          let images = variants_media.skipped.concat(variants_media.g);
          return images.length ? images : variant_assigned_media;
        }
        if (((selection_vid = 0), "showcase_only" == only_run_if_variant_in_url))
          return showcase_images();
        if ("showcase_and_variants" == only_run_if_variant_in_url)
          return variants_media.g.concat(variant_assigned_media);
        if ("featured_only" == only_run_if_variant_in_url)
          return [product_media[0]];
        if ("featured_and_showcase" == only_run_if_variant_in_url)
          return skip_showcase_image > 0
            ? [product_media[0]].concat(variants_media.g)
            : showcase_images();
        if ("skipped_and_showcase" == only_run_if_variant_in_url)
          return skipped_and_showcase_images();
        if ("show_all" == only_run_if_variant_in_url) return product_media;
      }
      return (
        "at_start" == general_images_position
          ? (variant_media = variants_media.g.concat(variant_media))
          : "at_end" == general_images_position &&
            (variant_media = variant_media.concat(variants_media.g)),
        variant_media && 0 != variant_media.length
          ? priority_video
            ? moveVideoToFront(variant_media)
            : variant_media
          : product_media
      );
    }
    function moveVideoToFront(arr) {
      const videoIndex = arr.findIndex(
        (obj) => "video" === obj.media_type || "external_video" === obj.media_type
      );
      if (videoIndex > -1) {
        const videoObj = arr.splice(videoIndex, 1)[0];
        arr.unshift(videoObj);
      }
      return arr;
    }
    var quick_view_enabled = !1,
      skip_showcase_image = 0,
      selected_theme_name = "Palo Alto V4",
      priority_video = !1,
      can_execute_script = !1,
      is_home = !1,
      only_run_if_variant_in_url = "no_action",
      limit_on_product = "none",
      product_url = "",
      is_product_preview =
        window.location.href.toLowerCase().indexOf("/products_preview") >= 0,
      is_product_page = /\/products\/|\/produkty\/|\/produkte\//.test(
        window.location.href.toLowerCase()
      ),
      is_pages =
        ((is_home = "/" == window.location.pathname),
        window.location.pathname.indexOf("/pages/") >= 0),
      variant_id = 0,
      selection_vid = 0,
      last_variant_images = {};
    if (
      ((is_home || is_pages || is_product_page || is_product_preview) &&
        (can_execute_script = !0),
      quick_view_enabled)
    )
      var jTimer = setInterval(function () {
        window.$ && window.jQuery && clearInterval(jTimer);
      }, 10);
    if (can_execute_script) {
      if (is_home) {
        if ("Startup" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="featured-product"] .product-title a'
          )
            ? document.querySelector(
                '[data-section-type="featured-product"] .product-title a'
              ).href
            : "";
        else if ("Flow" == selected_theme_name)
          product_url = document.querySelector(
            "#product-box .product-details--form-wrapper a"
          )
            ? document.querySelector(
                "#product-box .product-details--form-wrapper a"
              ).href
            : "";
        else if ("Debut" == selected_theme_name);
        else if ("Success theme" == selected_theme_name);
        else if ("Supply V2" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="product-template"] a.full-details'
          )
            ? document.querySelector(
                '[data-section-type="product-template"] a.full-details'
              ).href
            : "";
        else if ("Launch" == selected_theme_name)
          product_url = document.querySelector(
            ".home-featured-product .product-title a"
          )
            ? document.querySelector(".home-featured-product .product-title a")
                .href
            : "";
        else if ("Responsive" == selected_theme_name)
          product_url = document.querySelector(
            ".featured-product-section .product_name a"
          )
            ? document.querySelector(".featured-product-section .product_name a")
                .href
            : "";
        else if ("Streamline" == selected_theme_name);
        else if ("Broadcast" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="product"] .product__title a'
          )
            ? document.querySelector(
                '[data-section-type="product"] .product__title a'
              ).href
            : "";
        else if ("Palo Alto V2" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="featured-product"]:first-child .featured-product-title a'
          )
            ? document.querySelector(
                '[data-section-type="featured-product"]:first-child .featured-product-title a'
              ).href
            : "";
        else if ("Startup V3" == selected_theme_name)
          product_url = document.querySelector(".product-title a")
            ? document.querySelector(".product-title a").href
            : "";
        else if (
          [
            "Turbo",
            "Turbo Seoul",
            "Turbo Florence",
            "Turbo Portland",
            "Turbo Chicago",
            "Turbo Dubai",
            "Turbo Tennessee",
          ].indexOf(selected_theme_name) >= 0
        )
          product_url = document.querySelector(".product_section .product_name a")
            ? document.querySelector(".product_section .product_name a").href
            : "";
        else if ("Palo Alto V3" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="featured-product"] .featured-product-title a'
          )
            ? document.querySelector(
                '[data-section-type="featured-product"] .featured-product-title a'
              ).href
            : "";
        else if ("Warehouse" == selected_theme_name)
          product_url = document.querySelector(
            '[data-section-type="product"]:last-child .product-meta__title a'
          )
            ? document.querySelector(
                '[data-section-type="product"]:last-child .product-meta__title a'
              ).href
            : "";
        else if ("Flex" == selected_theme_name)
          product_url = document.querySelector(
            ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
          )
            ? document.querySelector(
                ".shopify-section.featured-product-section.jsProduct .product-thumbnail__title a"
              ).href
            : "";
        else if (
          ["Empire V5.1", "Superstore V2"].indexOf(selected_theme_name) >= 0
        ) {
          let product_links = document.querySelectorAll(
            ".featured-product--container .product-link"
          );
          product_url = product_links.length
            ? product_links[product_links.length - 1].href
            : "";
        }
        product_url = product_url.replace(/\/$/, "").split("?")[0].split("#")[0];
      } else
        is_pages
          ? ("Broadcast" == selected_theme_name &&
              (product_url = document.querySelector(
                '[data-section-type="product"] .product__title a'
              )
                ? document.querySelector(
                    '[data-section-type="product"] .product__title a'
                  ).href
                : ""),
            (product_url = product_url
              .replace(/\/$/, "")
              .split("?")[0]
              .split("#")[0]))
          : (product_url = window.location.pathname
              .replace(/\/$/, "")
              .replace("//", "/"));
      if (
        product_url.length &&
        (void 0 === window.via_product_handle ||
          window.via_product_handle != product_url)
      ) {
        var productJson;
        window.via_product_handle = product_url;
        var variants = {},
          product_variants = {};
        (variants.g = []), (variants.skipped = []);
        var product_images = [],
          default_variant = 0,
          general_images_position = "at_end",
          hide_single_thumb = !1,
          variant_assigned_images = [],
          variants_media = {},
          product_media = [];
        (variants_media.g = []), (variants_media.skipped = []);
        var variant_assigned_media = [],
          product_tags = "",
          variant_assigned_images_ids = [],
          variant_assigned_media_ids = [],
          all_variant_media = [],
          all_variant_images = [];
          var ql_all_variants = [];
        //   console.log("----", product_media, ql_arr_hb_all_variants);
        function assign_variants_media(productJson) {
          (ql_arr_hb_all_media ?(product_media = ql_arr_hb_all_media ):(product_media = productJson.media)),
          (ql_arr_hb_all_variants ? (ql_all_variants = ql_arr_hb_all_variants) : (ql_all_variants = productJson.variants) ),
            ql_all_variants.forEach(function (variant) {
              variant.featured_image &&
                -1 ==
                  variant_assigned_images_ids.indexOf(
                    variant.featured_image.id
                  ) &&
                (variant_assigned_images_ids.push(variant.featured_image.id),
                variant_assigned_images.push(variant.featured_image)),
                variant.featured_media &&
                  -1 ==
                    variant_assigned_media_ids.indexOf(
                      variant.featured_media.id
                    ) &&
                  (variant_assigned_media_ids.push(variant.featured_media.id),
                  variant_assigned_media.push(variant.featured_media)),
                !default_variant &&
                  variant.available &&
                  (default_variant = variant.id),
                variant.featured_media &&
                  (all_variant_media[variant.featured_media.id] ||
                    (all_variant_media[variant.featured_media.id] = []),
                  all_variant_media[variant.featured_media.id].push(variant.id)),
                (variants_media[variant.id] = []),
                variant.featured_image &&
                  (all_variant_images[variant.featured_image.id] ||
                    (all_variant_images[variant.featured_image.id] = []),
                  all_variant_images[variant.featured_image.id].push(variant.id)),
                (variants[variant.id] = []),
                (product_variants[variant.id] = variant);
            });
            
          var general_media = !0,
            current_variant_ids = [];
          product_media.forEach(function (media, index) {
            general_media && -1 == variant_assigned_media_ids.indexOf(media.id)
              ? skip_showcase_image > 0 && index < skip_showcase_image
                ? variants_media.skipped.push(media)
                : variants_media.g.push(media)
              : ((general_media = !1),
                (current_variant_ids = all_variant_media[media.id]
                  ? all_variant_media[media.id]
                  : current_variant_ids).forEach(function (variant_id) {
                  variants_media[variant_id].push(media);
                }));
          });
        }
        function assign_variant_images(images) {
          var general_images = !0,
            current_variant_ids = [];
          (product_images = images).forEach(function (image, index) {
            general_images && -1 == variant_assigned_images_ids.indexOf(image.id)
              ? skip_showcase_image > 0 && index < skip_showcase_image
                ? variants.skipped.push(image)
                : variants.g.push(image)
              : ((general_images = !1),
                (current_variant_ids = all_variant_images[image.id]
                  ? all_variant_images[image.id]
                  : current_variant_ids).forEach(function (variant_id) {
                  variants[variant_id].push(image);
                }));
          });
        }
        function is_restrictable() {
          return (
            ("include_selected" == limit_on_product &&
              0 ==
                /via_enabled|viaenabled|via-enabled|__via_enabled/.test(
                  product_tags.toLowerCase()
                )) ||
            ("exclude_selected" == limit_on_product &&
              1 ==
                /via_disabled|via-disabled|viadisabled|__via_disabled/.test(
                  product_tags.toLowerCase()
                ))
          );
        }
        function get_ready_with_data(_callback) {
          var DONE = 4,
            OK = 200,
            xhr_for_js = new XMLHttpRequest();
          return (
            xhr_for_js.open("GET", product_url + ".js", !0),
            xhr_for_js.send(),
            (xhr_for_js.onreadystatechange = function () {
              if (xhr_for_js.readyState === DONE && xhr_for_js.status === OK) {
                if (
                  ((productJson = JSON.parse(xhr_for_js.responseText)),
                  (product_tags = productJson.tags.join()),
                  (void 0 === productJson.media ||
                    0 == productJson.media.length) &&
                    0 == productJson.images.length)
                )
                  return;
                assign_variants_media(productJson);
                var xhr_for_json = new XMLHttpRequest();
                xhr_for_json.open("GET", product_url + ".json", !0),
                  xhr_for_json.send(),
                  (xhr_for_json.onreadystatechange = function () {
                    xhr_for_json.readyState === DONE &&
                      xhr_for_json.status === OK &&
                      (assign_variant_images(
                        JSON.parse(xhr_for_json.responseText).product.images
                      ),
                      _callback());
                  });
              }
            }),
            !0
          );
        }
        function processJSONInformation() {
          (product_tags = productJson.tags.join()),
            assign_variants_media(productJson),
            assign_variant_images(productJson.product_images),
            execute_app_code();
        }
        function run() {
          if (is_product_preview)
            try {
              (productJson = JSON.parse(
                document.querySelector("[sa-product-json]").innerText
              )),
                processJSONInformation();
            } catch (e) {
              setTimeout(function () {
                run();
              }, 100);
            }
          else if (document.querySelector("[sa-product-json]"))
            try {
              (productJson = JSON.parse(
                document.querySelector("[sa-product-json]").innerText
              )).media && processJSONInformation();
            } catch (e) {}
          is_product_preview ||
            (productJson && productJson.media) ||
            get_ready_with_data(execute_app_code);
        }
        function execute_app_code() {
          if (
            !(
              is_restrictable() ||
              (1 == product_media.length && 1 == product_images.length)
            )
          )
            var nTimer = setInterval(function () {
              if (
                "interactive" == document.readyState ||
                "complete" == document.readyState
              ) {
                clearInterval(nTimer);
                const settings$2 = { unlockScrollDelay: 400 },
                  selectors$e = {
                    popupContainer: ".pswp",
                    popupCloseBtn: ".pswp__custom-close",
                    popupIframe: "iframe, video",
                    popupCustomIframe: ".pswp__custom-iframe",
                    popupThumbs: ".pswp__thumbs",
                    popupButtons: ".pswp__button, .pswp__caption-close",
                    product: "[data-product]",
                    productJSON: "[data-product-json]",
                  },
                  classes$c = {
                    current: "is-current",
                    customLoader: "pswp--custom-loader",
                    customOpen: "pswp--custom-opening",
                    loader: "pswp__loader",
                    opened: "pswp--open",
                    popupCloseButton: "pswp__button--close",
                    notificationPopup: "pswp--notification",
                    quickviewPopup: "popup-quick-view",
                    isCartDrawerOpen: "js-drawer-open-cart",
                  },
                  attributes$a = {
                    dataOptionClasses: "data-pswp-option-classes",
                    dataVideoType: "data-video-type",
                    sectionId: "data-section-id",
                  },
                  loaderHTML = `<div class="${classes$c.loader}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
                class LoadPhotoswipe {
                  constructor(
                    items,
                    options = "",
                    templateIndex = 0,
                    triggerButton = null
                  ) {
                    (this.items = items),
                      (this.triggerBtn = triggerButton),
                      (this.pswpElements = document.querySelectorAll(
                        selectors$e.popupContainer
                      )),
                      (this.pswpElement = this.pswpElements[templateIndex]),
                      (this.popup = null),
                      (this.popupThumbs = null),
                      (this.popupThumbsContainer = this.pswpElement.querySelector(
                        selectors$e.popupThumbs
                      )),
                      (this.closeBtn = this.pswpElement.querySelector(
                        selectors$e.popupCloseBtn
                      ));
                    const defaultOptions = {
                      history: !1,
                      focus: !1,
                      mainClass: "",
                    };
                    (this.options = "" !== options ? options : defaultOptions),
                      (this.onCloseCallback = () => this.onClose()),
                      (this.dispatchPopupInitEventCallback = () =>
                        this.dispatchPopupInitEvent()),
                      (this.setCurrentThumbCallback = () =>
                        this.setCurrentThumb()),
                      this.init();
                  }
                  init() {
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                    ),
                      this.pswpElement.classList.add(classes$c.customOpen),
                      this.initLoader(),
                      loadScript({ url: window.theme.assets.photoswipe })
                        .then(() => this.loadPopup())
                        .catch((e) => console.error(e));
                  }
                  initLoader() {
                    if (
                      this.pswpElement.classList.contains(
                        classes$c.customLoader
                      ) &&
                      "" !== this.options &&
                      this.options.mainClass
                    ) {
                      this.pswpElement.setAttribute(
                        attributes$a.dataOptionClasses,
                        this.options.mainClass
                      );
                      let loaderElem = document.createElement("div");
                      (loaderElem.innerHTML = loaderHTML),
                        (loaderElem = loaderElem.firstChild),
                        this.pswpElement.appendChild(loaderElem);
                    } else
                      this.pswpElement.setAttribute(
                        attributes$a.dataOptionClasses,
                        ""
                      );
                  }
                  loadPopup() {
                    const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default,
                      PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
                    this.pswpElement.classList.contains(classes$c.customLoader) &&
                      this.pswpElement.classList.remove(classes$c.customLoader),
                      this.pswpElement.classList.remove(classes$c.customOpen),
                      (this.popup = new PhotoSwipe(
                        this.pswpElement,
                        PhotoSwipeUI,
                        this.items,
                        this.options
                      )),
                      this.popup.listen(
                        "afterInit",
                        this.dispatchPopupInitEventCallback
                      ),
                      this.popup.listen(
                        "imageLoadComplete",
                        this.setCurrentThumbCallback
                      ),
                      this.popup.listen(
                        "beforeChange",
                        this.setCurrentThumbCallback
                      ),
                      this.popup.listen("close", this.onCloseCallback),
                      this.popup.init(),
                      this.initPopupCallback();
                  }
                  initPopupCallback() {
                    this.isVideo && this.hideUnusedButtons(),
                      this.initVideo(),
                      this.thumbsActions(),
                      slate.a11y.trapFocus({ container: this.pswpElement }),
                      this.pswpElement.classList.contains(
                        classes$c.quickviewPopup
                      ) && new LoadQuickview(this.popup, this.pswpElement),
                      this.pswpElement.classList.contains(
                        classes$c.notificationPopup
                      ) && new LoadNotification(this.popup, this.pswpElement),
                      (this.closePopup = () => this.popup.close()),
                      this.closeBtn &&
                        this.closeBtn.addEventListener("click", this.closePopup),
                      document.addEventListener(
                        "theme:cart:added",
                        this.closePopup
                      );
                  }
                  dispatchPopupInitEvent() {
                    this.triggerBtn &&
                      this.triggerBtn.dispatchEvent(
                        new CustomEvent("theme:popup:init", { bubbles: !0 })
                      );
                  }
                  initVideo() {
                    const videoContainer = this.pswpElement.querySelector(
                      selectors$e.popupCustomIframe
                    );
                    if (videoContainer) {
                      const videoType = videoContainer.getAttribute(
                        attributes$a.dataVideoType
                      );
                      (this.isVideo = !0),
                        "youtube" == videoType
                          ? new LoadVideoYT(videoContainer.parentElement)
                          : "vimeo" == videoType &&
                            new LoadVideoVimeo(videoContainer.parentElement);
                    }
                  }
                  thumbsActions() {
                    this.popupThumbsContainer &&
                      this.popupThumbsContainer.firstChild &&
                      (this.popupThumbsContainer.addEventListener("wheel", (e) =>
                        this.stopDisabledScroll(e)
                      ),
                      this.popupThumbsContainer.addEventListener(
                        "mousewheel",
                        (e) => this.stopDisabledScroll(e)
                      ),
                      this.popupThumbsContainer.addEventListener(
                        "DOMMouseScroll",
                        (e) => this.stopDisabledScroll(e)
                      ),
                      (this.popupThumbs = this.pswpElement.querySelectorAll(
                        `${selectors$e.popupThumbs} > *`
                      )),
                      this.popupThumbs.forEach((element, i) => {
                        element.addEventListener("click", (e) => {
                          e.preventDefault(),
                            element.parentElement
                              .querySelector(`.${classes$c.current}`)
                              .classList.remove(classes$c.current),
                            element.classList.add(classes$c.current),
                            this.popup.goTo(i);
                        });
                      }));
                  }
                  hideUnusedButtons() {
                    this.pswpElement
                      .querySelectorAll(selectors$e.popupButtons)
                      .forEach((element) => {
                        element.classList.contains(classes$c.popupCloseButton) ||
                          (element.style.display = "none");
                      });
                  }
                  stopDisabledScroll(e) {
                    e.stopPropagation();
                  }
                  onClose() {
                    const popupIframe = this.pswpElement.querySelector(
                      selectors$e.popupIframe
                    );
                    if (
                      (popupIframe &&
                        popupIframe.parentNode.removeChild(popupIframe),
                      this.popupThumbsContainer &&
                        this.popupThumbsContainer.firstChild)
                    )
                      for (; this.popupThumbsContainer.firstChild; )
                        this.popupThumbsContainer.removeChild(
                          this.popupThumbsContainer.firstChild
                        );
                    this.pswpElement.setAttribute(
                      attributes$a.dataOptionClasses,
                      ""
                    );
                    const loaderElem = this.pswpElement.querySelector(
                      `.${classes$c.loader}`
                    );
                    loaderElem && this.pswpElement.removeChild(loaderElem),
                      slate.a11y.removeTrapFocus({ container: this.pswpElement }),
                      document.removeEventListener(
                        "theme:cart:added",
                        this.closePopup
                      ),
                      setTimeout(() => {
                        const recentlyOpenedPopups =
                            this.recentlyOpenedPopupsCount(),
                          isCartDrawerOpen = document.body.classList.contains(
                            classes$c.isCartDrawerOpen
                          );
                        0 !== recentlyOpenedPopups ||
                          isCartDrawerOpen ||
                          document.dispatchEvent(
                            new CustomEvent("theme:scroll:unlock", {
                              bubbles: !0,
                            })
                          );
                      }, settings$2.unlockScrollDelay);
                  }
                  recentlyOpenedPopupsCount() {
                    let count = 0;
                    return (
                      this.pswpElements.forEach((popup) => {
                        popup.classList.contains(classes$c.opened) &&
                          (count += 1);
                      }),
                      count
                    );
                  }
                  setCurrentThumb() {
                    if (
                      this.popupThumbsContainer &&
                      this.popupThumbsContainer.firstChild
                    )
                      return;
                    const lastCurrentThumb = this.pswpElement.querySelector(
                      `${selectors$e.popupThumbs} > .${classes$c.current}`
                    );
                    if (
                      (lastCurrentThumb &&
                        lastCurrentThumb.classList.remove(classes$c.current),
                      !this.popupThumbs)
                    )
                      return;
                    const currentThumb =
                      this.popupThumbs[this.popup.getCurrentIndex()];
                    currentThumb.classList.add(classes$c.current),
                      this.scrollThumbs(currentThumb);
                  }
                  scrollThumbs(currentThumb) {
                    const thumbsContainerPos =
                        this.popupThumbsContainer.scrollLeft +
                        this.popupThumbsContainer.offsetWidth,
                      currentThumbLeft = currentThumb.offsetLeft;
                    if (
                      thumbsContainerPos <=
                        currentThumbLeft + currentThumb.offsetWidth ||
                      thumbsContainerPos > currentThumbLeft
                    ) {
                      const currentThumbMarginLeft = parseInt(
                        window.getComputedStyle(currentThumb).marginLeft
                      );
                      this.popupThumbsContainer.scrollTo({
                        top: 0,
                        left: currentThumbLeft - currentThumbMarginLeft,
                        behavior: "smooth",
                      });
                    }
                  }
                }
                function getScript(url, callback, callbackError) {
                  let head = document.getElementsByTagName("head")[0],
                    done = !1,
                    script = document.createElement("script");
                  (script.src = url),
                    (script.onload = script.onreadystatechange =
                      function () {
                        done ||
                        (this.readyState &&
                          "loaded" != this.readyState &&
                          "complete" != this.readyState)
                          ? callbackError()
                          : ((done = !0), callback());
                      }),
                    head.appendChild(script);
                }
                const loaders = {};
                function loadScript(options = {}) {
                  if ((options.type || (options.type = "json"), options.url))
                    return loaders[options.url]
                      ? loaders[options.url]
                      : getScriptWithPromise(options.url, options.type);
                  if (options.json)
                    return loaders[options.json]
                      ? Promise.resolve(loaders[options.json])
                      : window
                          .fetch(options.json)
                          .then((response) => response.json())
                          .then(
                            (response) => (
                              (loaders[options.json] = response), response
                            )
                          );
                  if (options.name) {
                    const key = "".concat(options.name, options.version);
                    return loaders[key]
                      ? loaders[key]
                      : loadShopifyWithPromise(options);
                  }
                  return Promise.reject();
                }
                function getScriptWithPromise(url, type) {
                  const loader = new Promise((resolve, reject) => {
                    "text" === type
                      ? fetch(url)
                          .then((response) => response.text())
                          .then((data) => {
                            resolve(data);
                          })
                          .catch((error) => {
                            reject(error);
                          })
                      : getScript(
                          url,
                          function () {
                            resolve();
                          },
                          function () {
                            reject();
                          }
                        );
                  });
                  return (loaders[url] = loader), loader;
                }
                function loadShopifyWithPromise(options) {
                  const key = "".concat(options.name, options.version),
                    loader = new Promise((resolve, reject) => {
                      try {
                        window.Shopify.loadFeatures([
                          {
                            name: options.name,
                            version: options.version,
                            onLoad: (err) => {
                              onLoadFromShopify(resolve, reject, err);
                            },
                          },
                        ]);
                      } catch (err) {
                        reject(err);
                      }
                    });
                  return (loaders[key] = loader), loader;
                }
                function flickitySmoothScrolling(slider) {
                  const flkty = Flickity.data(slider);
                  flkty &&
                    (flkty.on("dragStart", () => {
                      document.ontouchmove = function (e) {
                        e.preventDefault();
                      };
                    }),
                    flkty.on("dragEnd", () => {
                      document.ontouchmove = function () {
                        return !0;
                      };
                    }));
                }
                (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
                const hosts = {
                    html5: "html5",
                    youtube: "youtube",
                    vimeo: "vimeo",
                  },
                  selectors$5 = {
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaContainer: "[data-video]",
                    mediaHidden: ".media--hidden",
                  },
                  classes$5 = { mediaHidden: "media--hidden" },
                  attributes$3 = {
                    loaded: "loaded",
                    sectionId: "data-section-id",
                    dataAutoplayVideo: "data-autoplay-video",
                    mediaId: "data-media-id",
                  };
                class ProductVideo {
                  constructor(container) {
                    (this.container = container),
                      (this.id = this.container.getAttribute(
                        attributes$3.sectionId
                      )),
                      (this.autoplayVideo =
                        "true" ===
                        this.container.getAttribute(
                          attributes$3.dataAutoplayVideo
                        )),
                      (this.players = {}),
                      this.init();
                  }
                  init() {
                    this.container
                      .querySelectorAll(selectors$5.mediaContainer)
                      .forEach((mediaContainer) => {
                        const deferredMediaButton = mediaContainer.querySelector(
                          selectors$5.deferredMediaButton
                        );
                        deferredMediaButton &&
                          deferredMediaButton.addEventListener(
                            "click",
                            this.loadContent.bind(this, mediaContainer)
                          ),
                          this.autoplayVideo && this.loadContent(mediaContainer);
                      });
                  }
                  loadContent(mediaContainer) {
                    if (
                      mediaContainer
                        .querySelector(selectors$5.deferredMedia)
                        .getAttribute(attributes$3.loaded)
                    )
                      return;
                    const content = document.createElement("div");
                    content.appendChild(
                      mediaContainer
                        .querySelector("template")
                        .content.firstElementChild.cloneNode(!0)
                    );
                    const mediaId = mediaContainer.dataset.mediaId,
                      element = content.querySelector("video, iframe"),
                      host = this.hostFromVideoElement(element),
                      deferredMedia = mediaContainer.querySelector(
                        selectors$5.deferredMedia
                      );
                    deferredMedia.appendChild(element),
                      deferredMedia.setAttribute("loaded", !0),
                      (this.players[mediaId] = {
                        mediaId: mediaId,
                        sectionId: this.id,
                        container: mediaContainer,
                        element: element,
                        host: host,
                        ready: () => {
                          this.createPlayer(mediaId);
                        },
                      });
                    const video = this.players[mediaId];
                    switch (video.host) {
                      case hosts.html5:
                        this.loadVideo(video, hosts.html5);
                        break;
                      case hosts.vimeo:
                        window.isVimeoAPILoaded
                          ? this.loadVideo(video, hosts.vimeo)
                          : loadScript({
                              url: "https://player.vimeo.com/api/player.js",
                            }).then(() => this.loadVideo(video, hosts.vimeo));
                        break;
                      case hosts.youtube:
                        window.isYoutubeAPILoaded
                          ? this.loadVideo(video, hosts.youtube)
                          : loadScript({
                              url: "https://www.youtube.com/iframe_api",
                            }).then(() => this.loadVideo(video, hosts.youtube));
                    }
                  }
                  hostFromVideoElement(video) {
                    if ("VIDEO" === video.tagName) return hosts.html5;
                    if ("IFRAME" === video.tagName) {
                      if (
                        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
                          video.src
                        )
                      )
                        return hosts.youtube;
                      if (video.src.includes("vimeo.com")) return hosts.vimeo;
                    }
                    return null;
                  }
                  loadVideo(video, host) {
                    video.host === host && video.ready();
                  }
                  createPlayer(mediaId) {
                    const video = this.players[mediaId];
                    switch (video.host) {
                      case hosts.html5:
                        video.element.addEventListener("play", () => {
                          video.container.dispatchEvent(
                            new CustomEvent("theme:media:play"),
                            { bubbles: !0 }
                          );
                        });
                        const playPromise = video.element.play();
                        void 0 !== playPromise &&
                          playPromise.then(() => {}).catch(() => {}),
                          video.container.addEventListener(
                            "theme:media:visible",
                            (event) => this.onVisible(event)
                          ),
                          video.container.addEventListener(
                            "theme:media:hidden",
                            (event) => this.onHidden(event)
                          ),
                          video.container.addEventListener("xrLaunch", (event) =>
                            this.onHidden(event)
                          ),
                          this.autoplayVideo && this.observeVideo(video, mediaId);
                        break;
                      case hosts.vimeo:
                        (this.players[mediaId].player = new Vimeo.Player(
                          video.element
                        )),
                          this.players[mediaId].player.play(),
                          video.container.dispatchEvent(
                            new CustomEvent("theme:media:play"),
                            { bubbles: !0 }
                          ),
                          (window.isVimeoAPILoaded = !0),
                          video.container.addEventListener(
                            "theme:media:visible",
                            (event) => this.onVisible(event)
                          ),
                          video.container.addEventListener(
                            "theme:media:hidden",
                            (event) => this.onHidden(event)
                          ),
                          video.container.addEventListener("xrLaunch", (event) =>
                            this.onHidden(event)
                          ),
                          this.autoplayVideo && this.observeVideo(video, mediaId);
                        break;
                      case hosts.youtube:
                        if (video.host == hosts.youtube && video.player) return;
                        YT.ready(() => {
                          const videoId = video.container.dataset.videoId;
                          (this.players[mediaId].player = new YT.Player(
                            video.element,
                            {
                              videoId: videoId,
                              events: {
                                onReady: (event) => {
                                  event.target.playVideo(),
                                    video.container.dispatchEvent(
                                      new CustomEvent("theme:media:play"),
                                      { bubbles: !0 }
                                    );
                                },
                                onStateChange: (event) => {
                                  1 == event.data &&
                                    video.container.dispatchEvent(
                                      new CustomEvent("theme:media:play"),
                                      { bubbles: !0 }
                                    ),
                                    2 == event.data &&
                                      video.container.dispatchEvent(
                                        new CustomEvent("theme:media:pause"),
                                        { bubbles: !0 }
                                      );
                                },
                              },
                            }
                          )),
                            (window.isYoutubeAPILoaded = !0),
                            video.container.addEventListener(
                              "theme:media:visible",
                              (event) => this.onVisible(event)
                            ),
                            video.container.addEventListener(
                              "theme:media:hidden",
                              (event) => this.onHidden(event)
                            ),
                            video.container.addEventListener(
                              "xrLaunch",
                              (event) => this.onHidden(event)
                            ),
                            this.autoplayVideo &&
                              this.observeVideo(video, mediaId);
                        });
                    }
                    video.container.addEventListener("theme:media:play", () =>
                      this.pauseOtherMedia(mediaId)
                    );
                  }
                  observeVideo(video) {
                    new IntersectionObserver(
                      (entries) => {
                        entries.forEach((entry) => {
                          const outsideViewport = 0 == entry.intersectionRatio,
                            isVisible = !video.element.closest(
                              selectors$5.mediaHidden
                            );
                          outsideViewport
                            ? this.pauseVideo(video)
                            : isVisible && this.playVideo(video);
                        });
                      },
                      { threshold: 0 }
                    ).observe(video.element);
                  }
                  playVideo(video) {
                    video.player && video.player.playVideo
                      ? video.player.playVideo()
                      : video.element && video.element.play
                      ? video.element.play()
                      : video.player && video.player.play && video.player.play(),
                      video.container.dispatchEvent(
                        new CustomEvent("theme:media:play"),
                        { bubbles: !0 }
                      );
                  }
                  pauseVideo(video) {
                    video.player && video.player.pauseVideo
                      ? video.player.pauseVideo()
                      : video.element && video.element.pause
                      ? video.element.pause()
                      : video.player &&
                        video.player.pause &&
                        video.player.pause(),
                      video.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      );
                  }
                  onHidden(event) {
                    if (void 0 !== event.target.dataset.mediaId) {
                      const mediaId = event.target.dataset.mediaId,
                        video = this.players[mediaId];
                      this.pauseVideo(video);
                    }
                  }
                  onVisible(event) {
                    if (void 0 !== event.target.dataset.mediaId) {
                      const mediaId = event.target.dataset.mediaId,
                        video = this.players[mediaId];
                      this.playVideo(video), this.pauseOtherMedia(mediaId);
                    }
                  }
                  pauseOtherMedia(mediaId) {
                    const currentMedia = `[${attributes$3.mediaId}="${mediaId}"]`,
                      otherMedia = document.querySelectorAll(
                        `${selectors$5.productMediaWrapper}:not(${currentMedia})`
                      );
                    otherMedia.length &&
                      otherMedia.forEach((media) => {
                        media.dispatchEvent(
                          new CustomEvent("theme:media:hidden"),
                          { bubbles: !0 }
                        ),
                          media.classList.add(classes$5.mediaHidden);
                      });
                  }
                }
                const selectors$J = {
                    mediaContainer: "[data-product-single-media-group]",
                    productMediaSlider: "[data-product-single-media-slider]",
                    zoomWrapper: "[data-zoom-wrapper]",
                  },
                  classes$x = {
                    popupClass: "pswp-zoom-gallery",
                    popupClassNoThumbs: "pswp-zoom-gallery--single",
                    isMoving: "is-moving",
                  },
                  attributes$r = {
                    dataImageWidth: "data-image-width",
                    dataImageHeight: "data-image-height",
                  };
                class Zoom {
                  constructor(container) {
                    (this.container = container),
                      (this.mediaContainer = this.container.querySelector(
                        selectors$J.mediaContainer
                      )),
                      (this.slider = this.container.querySelector(
                        selectors$J.productMediaSlider
                      )),
                      (this.zoomWrappers = this.container.querySelectorAll(
                        selectors$J.zoomWrapper
                      )),
                      (this.zoomEnable =
                        "true" === this.mediaContainer.dataset.gallery),
                      this.zoomEnable && this.init();
                  }
                  init() {
                    this.zoomWrappers.length &&
                      this.zoomWrappers.forEach((element, i) => {
                        element.addEventListener("click", (e) => {
                          e.preventDefault();
                          (this.slider &&
                            this.slider.classList.contains(classes$x.isMoving)) ||
                            ((slate.a11y.state.trigger = element),
                            this.createZoom(i));
                        });
                      });
                  }
                  createZoom(indexImage) {
                    const instance = this;
                    let items = [],
                      counter = 0;
                    this.zoomWrappers.forEach((elementImage) => {
                      const imgSrc = elementImage.getAttribute("href"),
                        imgWidth = parseInt(
                          elementImage.getAttribute(attributes$r.dataImageWidth)
                        ),
                        imgHeight = parseInt(
                          elementImage.getAttribute(attributes$r.dataImageHeight)
                        );
                      if (
                        (items.push({
                          src: imgSrc,
                          w: imgWidth,
                          h: imgHeight,
                          msrc: imgSrc,
                        }),
                        (counter += 1),
                        instance.zoomWrappers.length === counter)
                      ) {
                        let popupClass = `${classes$x.popupClass}`;
                        1 === counter &&
                          (popupClass = `${classes$x.popupClass} ${classes$x.popupClassNoThumbs}`);
                        new LoadPhotoswipe(items, {
                          barsSize: { top: 60, bottom: 60 },
                          history: !1,
                          focus: !1,
                          index: indexImage,
                          mainClass: popupClass,
                          showHideOpacity: !0,
                          showAnimationDuration: 250,
                          hideAnimationDuration: 250,
                          closeOnScroll: !1,
                          closeOnVerticalDrag: !1,
                          captionEl: !1,
                          closeEl: !0,
                          closeElClasses: ["caption-close"],
                          tapToClose: !1,
                          clickToCloseNonZoomable: !1,
                          maxSpreadZoom: 2,
                          loop: !0,
                          spacing: 0,
                          allowPanToNext: !0,
                          pinchToClose: !1,
                        });
                      }
                    });
                  }
                }
                const selectors$K = {
                    productMediaSlider: "[data-product-single-media-slider]",
                    productMediaThumb: "[data-thumbnail-id]",
                    productMediaThumbs: "[data-product-single-media-thumbs]",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    productModel: "[data-model]",
                    productSingleThumbnailLink: ".product-single__thumbnail-link",
                    deferredMedia: "[data-deferred-media]",
                    deferredMediaButton: "[data-deferred-media-button]",
                    links: "a, button",
                  },
                  classes$y = {
                    hasMediaActive: "has-media-active",
                    isSelected: "is-selected",
                    mediaHidden: "media--hidden",
                    noOutline: "no-outline",
                    hasPopup: "has-popup",
                    isMoving: "is-moving",
                  },
                  attributes$s = {
                    mediaId: "data-media-id",
                    sectionId: "data-section-id",
                    thumbId: "data-thumbnail-id",
                    dataTallLayout: "data-tall-layout",
                    loaded: "loaded",
                    tabindex: "tabindex",
                  };
                class Product {
                  constructor(section) {
                    (this.container = section),
                      (this.sectionId = this.container.getAttribute(
                        attributes$s.sectionId
                      )),
                      (this.tallLayout =
                        "true" ===
                        this.container.getAttribute(attributes$s.dataTallLayout)),
                      (this.isFlickityDragging = !1),
                      (this.flktyNavResize = null),
                      new Zoom(this.container),
                      this.checkSlider(),
                      this.initMediaSwitch(),
                      this.initProductVideo(),
                      this.initProductModel(),
                      this.initShopifyXrLaunch();
                  }
                  checkSlider() {
                    (!this.tallLayout ||
                      window.innerWidth <= theme.sizes.large) &&
                      this.initProductSlider();
                  }
                  initProductSlider() {
                    const slider = this.container.querySelector(
                        selectors$K.productMediaSlider
                      ),
                      thumbs = this.container.querySelector(
                        selectors$K.productMediaThumbs
                      ),
                      media = this.container.querySelectorAll(
                        selectors$K.productMediaWrapper
                      );
                    if (media.length > 1) {
                      const flkty = new Flickity(slider, {
                        wrapAround: !0,
                        pageDots: !1,
                        adaptiveHeight: !0,
                        on: {
                          ready: () => {
                            slider.setAttribute(attributes$s.tabindex, "-1"),
                              media.forEach((item) => {
                                if (
                                  !item.classList.contains(classes$y.isSelected)
                                ) {
                                  const links = item.querySelectorAll(
                                    selectors$K.links
                                  );
                                  links.length &&
                                    links.forEach((link) => {
                                      link.setAttribute(
                                        attributes$s.tabindex,
                                        "-1"
                                      );
                                    });
                                }
                              });
                          },
                          dragStart: () => {
                            slider.classList.add(classes$y.isMoving);
                          },
                          dragMove: () => {
                            this.isFlickityDragging = !0;
                          },
                          staticClick: () => {
                            this.isFlickityDragging = !1;
                          },
                          settle: (index) => {
                            const mediaId = flkty.selectedElement.getAttribute(
                              attributes$s.mediaId
                            );
                            flkty.cells.forEach((slide, i) => {
                              const links = slide.element.querySelectorAll(
                                selectors$K.links
                              );
                              links.length &&
                                links.forEach((link) => {
                                  link.setAttribute(
                                    attributes$s.tabindex,
                                    i === index ? "0" : "-1"
                                  );
                                });
                            }),
                              this.switchMedia(mediaId),
                              slider.classList.remove(classes$y.isMoving);
                          },
                        },
                      });
                      if (
                        (media.length &&
                          media.forEach((el) => {
                            el.addEventListener("theme:media:play", () => {
                              (flkty.options.draggable = !1),
                                flkty.updateDraggable(),
                                el
                                  .closest(selectors$K.productMediaSlider)
                                  .classList.add(classes$y.hasMediaActive);
                            }),
                              el.addEventListener("theme:media:pause", () => {
                                (flkty.options.draggable = !0),
                                  flkty.updateDraggable(),
                                  el
                                    .closest(selectors$K.productMediaSlider)
                                    .classList.remove(classes$y.hasMediaActive);
                              });
                          }),
                        flickitySmoothScrolling(slider),
                        null !== thumbs)
                      ) {
                        const flktyNav = new Flickity(thumbs, {
                          asNavFor: slider,
                          contain: !0,
                          pageDots: !1,
                          prevNextButtons: !1,
                          resize: !0,
                          on: {
                            ready: () => {
                              thumbs.setAttribute(attributes$s.tabindex, "-1");
                            },
                          },
                        });
                        (this.flktyNavResize = () => flktyNav.resize()),
                          document.addEventListener(
                            "theme:resize:width",
                            this.flktyNavResize
                          ),
                          flickitySmoothScrolling(thumbs);
                        const thumbLinks = this.container.querySelectorAll(
                          selectors$K.productSingleThumbnailLink
                        );
                        thumbLinks.length &&
                          thumbLinks.forEach((el) => {
                            el.addEventListener("click", (e) => {
                              e.preventDefault();
                            });
                          });
                      }
                    }
                  }
                  handleMediaFocus(e) {
                    if (
                      e.keyCode !== theme.keyboardKeys.ENTER &&
                      e.keyCode !== theme.keyboardKeys.TAB
                    )
                      return;
                    const mediaId = e.currentTarget.getAttribute(
                        attributes$s.thumbId
                      ),
                      activeSlide = this.container.querySelector(
                        `[${attributes$s.mediaId}="${mediaId}"]`
                      ),
                      slideIndex = parseInt(
                        [...activeSlide.parentNode.children].indexOf(activeSlide)
                      ),
                      slider = this.container.querySelector(
                        selectors$K.productMediaSlider
                      ),
                      sliderNav = this.container.querySelector(
                        selectors$K.productMediaThumbs
                      ),
                      flkty = Flickity.data(slider) || null,
                      flktyNav = Flickity.data(sliderNav) || null;
                    flkty &&
                      flkty.isActive &&
                      slideIndex > -1 &&
                      e.keyCode === theme.keyboardKeys.ENTER &&
                      flkty.select(slideIndex),
                      flktyNav &&
                        flktyNav.isActive &&
                        slideIndex > -1 &&
                        flktyNav.select(slideIndex);
                  }
                  switchMedia(mediaId) {
                    const mediaItems = document.querySelectorAll(
                        `${selectors$K.productMediaWrapper}`
                      ),
                      selectedMedia = this.container.querySelector(
                        `${selectors$K.productMediaWrapper}[${attributes$s.mediaId}="${mediaId}"]`
                      ),
                      isFocusEnabled = !document.body.classList.contains(
                        classes$y.noOutline
                      );
                    mediaItems.length &&
                      mediaItems.forEach((media) => {
                        media.dispatchEvent(
                          new CustomEvent("theme:media:hidden"),
                          { bubbles: !0 }
                        ),
                          media.classList.add(classes$y.mediaHidden);
                      }),
                      isFocusEnabled && selectedMedia.focus(),
                      selectedMedia
                        .closest(selectors$K.productMediaSlider)
                        .classList.remove(classes$y.hasMediaActive),
                      selectedMedia.classList.remove(classes$y.mediaHidden),
                      selectedMedia.dispatchEvent(
                        new CustomEvent("theme:media:visible"),
                        { bubbles: !0 }
                      );
                    const deferredMedia = selectedMedia.querySelector(
                      selectors$K.deferredMedia
                    );
                    deferredMedia &&
                      "true" !==
                        deferredMedia.getAttribute(attributes$s.loaded) &&
                      selectedMedia
                        .querySelector(selectors$K.deferredMediaButton)
                        .dispatchEvent(new Event("click"));
                  }
                  initMediaSwitch() {
                    const productThumbImages = this.container.querySelectorAll(
                      selectors$K.productMediaThumb
                    );
                    productThumbImages.length &&
                      productThumbImages.forEach((el) => {
                        el.addEventListener(
                          "keyup",
                          this.handleMediaFocus.bind(this)
                        ),
                          el.addEventListener("click", (e) => {
                            e.preventDefault();
                          });
                      });
                  }
                  initProductVideo() {
                    this.videos = new ProductVideo(this.container);
                  }
                  initProductModel() {
                    const modelItems = this.container.querySelectorAll(
                      selectors$K.productModel
                    );
                    modelItems.length &&
                      modelItems.forEach((element) => {
                        PaloAlto.ProductModel.init(element, this.sectionId);
                      });
                  }
                  initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", () => {
                      this.container
                        .querySelector(
                          `${selectors$K.productModel}:not(.${classes$y.mediaHidden})`
                        )
                        .dispatchEvent(new CustomEvent("xrLaunch"));
                    });
                  }
                }
                if (
                  (create_element_append_to_body("div", "multi-variant-info"),
                  create_element_append_to_body("div", "multi-variant-thumb"),
                  is_home)
                )
                  var section = document.querySelector(
                    '[data-section-type="featured-product"]'
                  );
                else
                  section = document.querySelector(
                    '[data-section-type="product-template"]'
                  );
                var Flickity;
                section.getAttribute("data-section-id");
                create_element_append_to_body("div", "multi-variant-info"),
                  (document.getElementById("multi-variant-info").innerHTML =
                    section.querySelector(
                      "[data-product-single-media-slider]"
                    ).innerHTML),
                  (document.getElementById("multi-variant-thumb").innerHTML =
                    section.querySelector(
                      "[data-product-single-media-thumbs]"
                    ).innerHTML),
                  document
                    .querySelectorAll(
                      "#multi-variant-info img.lazyloading, #multi-variant-thumb img.lazyloading"
                    )
                    .forEach((image) => {
                      image.classList.remove("lazyloading"),
                        image.classList.add("lazyload");
                    });
                var zTimer = setInterval(function () {
                  if (
                    "object" == typeof themeVendor &&
                    "function" == typeof themeVendor.Flickity
                  ) {
                    clearInterval(zTimer), (Flickity = themeVendor.Flickity);
                    var selectors = document.querySelectorAll(
                      'select, .panda-swatch, .single-option-selector, label, .swatches .swatch-selector, .swatch .swatch-element, form[action="/cart/add"], [data-popout-list], .swatch__button'
                    );
                    function variant_change_event() {
                      setTimeout(function () {
                        (variant_id = find_current_variant()),
                          selection_vid != variant_id &&
                            (palo_alto4_change_images(variant_id),
                            (selection_vid = variant_id));
                      }, 100);
                    }
                    selectors &&
                      Object.entries(selectors).forEach(([index, selector]) => {
                        selector.addEventListener(
                          "click",
                          variant_change_event,
                          !1
                        ),
                          selector.addEventListener(
                            "change",
                            variant_change_event,
                            !1
                          );
                      }),
                      palo_alto4_change_images();
                  }
                }, 10);
                function palo_alto4_change_images(variant_id) {
                  if (
                    ((variant_images = find_variant_media(variant_id)),
                    !is_array_equal(last_variant_images, variant_images))
                  ) {
                    last_variant_images = variant_images;
                    var slide_images = "",
                      thumb_images = "";
                    variant_images.forEach((image) => {
                      let main = document.querySelector(
                        "#multi-variant-info .product-single__media-slide[data-id='" +
                          image.id +
                          "']"
                      );
                      main.classList.remove("is-selected"),
                        main.removeAttribute("style"),
                        (slide_images += main.outerHTML);
                      let thumb = document.querySelector(
                        "#multi-variant-thumb .product-single__thumbnail[data-id='" +
                          image.id +
                          "']"
                      );
                      thumb.classList.remove("is-selected", "is-nav-selected"),
                        thumb.removeAttribute("style"),
                        (thumb_images += thumb.outerHTML);
                    }),
                      Flickity.data(
                        ".product-single [data-product-single-media-slider]"
                      ) &&
                        Flickity.data(
                          ".product-single [data-product-single-media-slider]"
                        ).destroy(),
                      Flickity.data(
                        ".product-single [data-product-single-media-thumbs]"
                      ) &&
                        Flickity.data(
                          ".product-single [data-product-single-media-thumbs]"
                        ).destroy(),
                      (section.querySelector(
                        "[data-product-single-media-slider]"
                      ).innerHTML = slide_images),
                      (section.querySelector(
                        "[data-product-single-media-thumbs]"
                      ).innerHTML = thumb_images),
                      1 == variant_images.length && hide_single_thumb
                        ? (section.querySelector(
                            "[data-product-single-media-thumbs]"
                          ).style.display = "none")
                        : (section.querySelector(
                            "[data-product-single-media-thumbs]"
                          ).style.display = ""),
                      new Product(section);
                  }
                }
              }
            }, 10);
        }
        run();
      }
    }
  };
  variantImageAutomator();
  